export default function () {
    const entityStreamChapter = useEntityStreamChapter();

    async function get(filter) {
        let chapters = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('stream-chapters', filter);
            chapters = data.chapters.map((chapter) => {
                return entityStreamChapter.build(chapter);
            });
        } catch (e) {
            error = useApiError(e);
        }
        return {chapters, error};
    }

    return {get};
}
